import api from "@/lib/api";

// Privacy-safe gate funnel: a random visitor id (no PII) + the module whose gate was shown.
const VID = "fab_gate_vid";
const LAST = "fab_gate_last";
const WEEK = 7 * 24 * 3600 * 1000;

export function visitorId() {
  try {
    let v = localStorage.getItem(VID);
    if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, ""); localStorage.setItem(VID, v); }
    return v;
  } catch { return null; }
}

export function recordGateView(moduleId) {
  const vid = visitorId();
  if (!vid) return;
  try {
    const key = `fab_gate_seen_${moduleId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    localStorage.setItem(LAST, JSON.stringify({ module: moduleId, at: Date.now() }));
  } catch { /* storage unavailable */ }
  api.post("/gate/event", { type: "view", module_id: moduleId, visitor_id: vid }).catch(() => {});
}

export function recordGateSignup(method) {
  let last = null;
  try { last = JSON.parse(localStorage.getItem(LAST) || "null"); } catch { return; }
  const vid = visitorId();
  if (!last || !vid || Date.now() - last.at > WEEK) return;
  try { localStorage.removeItem(LAST); } catch { /* ignore */ }
  api.post("/gate/event", { type: "signup", module_id: last.module, visitor_id: vid, method }).catch(() => {});
}
